import { newE2EPage } from "@stencil/core/testing";

describe("uic-header", () => {
    it("should render slots correctly and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-header>
                <div slot="home">
                    Home Slot
                </div>
                <div slot="menu-left">
                    Left Slot
                </div>
                <div slot="menu-right">
                    Right Slot
                </div>
                <div slot="flyout">
                    Flyout Slot
                </div>
            </uic-header>`);
        const header = await page.find("uic-header.hydrated");
        await page.waitForChanges();
        expect(header).toMatchSnapshot();
    });

    it("should collapse the left menu if menu-items overlap available space", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <uic-header>
                <div slot="menu-left">
                    <uic-header-menu name="test-menu">
                        ${[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                            .map(
                                (value) =>
                                    // eslint-disable-next-line max-len
                                    `<uic-header-menu-item name="menu-item-${value}" label="Menu Item #${value} Label"></uic-header-menu-item>`
                            )
                            .join("\n")}
                    </uic-header-menu>
                </div>
            </uic-header>
        `);
        const header = await page.find("uic-header.hydrated");
        await page.waitForChanges();
        await page.find(`uic-header-menu[name="test-menu"].hydrated`);
        // The expand menu should be rendered
        await page.find(`.uic-header-menu[name="expand"].hydrated`);
        // The expand button should be rendered as menu-item
        await page.find(`.uic-header-menu-item[name="expand"].hydrated`);
        // The submenu should be rendered with hidden class modifier
        await page.find(`.uic-header__submenu--hidden`);
        expect(header).toMatchSnapshot();
    });
});
